angular.module('bizmetryApp').service('RolesService', ['$http', 'CONFIG', function ($http, CONFIG) {

  var BASE = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account';

  // 🌳 Obtener jerarquía completa de roles y permisos. sortBy es opcional
  // (el backend default a PERMISSIONS_DESC si se omite) — valores válidos:
  // PERMISSIONS_DESC | PERMISSIONS_ASC | NAME_ASC | NAME_DESC. El árbol
  // vuelve ya ordenado según ese criterio, a todos los niveles.
  this.getRolesHierarchy = function (accountId, sortBy) {
    return $http.get(`${BASE}/${accountId}/roles/permissions-hierarchy`, {
      params: sortBy ? { sortBy: sortBy } : {}
    });
  };

  // 📋 Obtener el catálogo completo (plano) de permisos del sistema
  this.getAllPermissions = function (accountId) {
    return $http.get(`${BASE}/${accountId}/permissions`);
  };

  // ➕ Crear un nuevo rol (name, description, authorizations iniciales)
  this.createRole = function (accountId, roleDTO) {
    return $http.post(`${BASE}/${accountId}/roles`, roleDTO, {
      headers: { 'Content-Type': 'application/json' }
    });
  };

  // ❌ Eliminar un rol existente
  this.deleteRole = function (accountId, roleId) {
    return $http.delete(`${BASE}/${accountId}/roles/${roleId}`);
  };

  // ✏️ Actualizar (parcialmente) un rol existente — típicamente name/description.
  // Campos omitidos/undefined se interpretan como "no modificar" del lado backend.
  this.updateRole = function (accountId, roleId, updateDTO) {
    return $http({
      method:  'PUT',
      url:     `${BASE}/${accountId}/roles/${roleId}`,
      data:    updateDTO,
      headers: { 'Content-Type': 'application/json' }
    });
  };

  // ➕ Agregar uno o más permisos a un rol existente
  this.addPermissionsToRole = function (accountId, roleId, permissionIds) {
    return $http.post(`${BASE}/${accountId}/roles/${roleId}/permissions`, permissionIds, {
      headers: { 'Content-Type': 'application/json' }
    });
  };

  // ❌ Eliminar uno o más permisos de un rol existente
  this.removePermissionsFromRole = function (accountId, roleId, permissionIds) {
    return $http({
      method:  'DELETE',
      url:     `${BASE}/${accountId}/roles/${roleId}/permissions`,
      data:    permissionIds,
      headers: { 'Content-Type': 'application/json' }
    });
  };

  // ➕ Agregar uno o más roles hijos ya existentes a un rol padre
  this.addChildRoles = function (accountId, roleId, childRoleIds) {
    return $http.post(`${BASE}/${accountId}/roles/${roleId}/roles`, childRoleIds, {
      headers: { 'Content-Type': 'application/json' }
    });
  };

  // ❌ Desvincular uno o más roles hijos de un rol padre (NO borra los roles hijos, solo la relación)
  this.removeChildRoles = function (accountId, roleId, childRoleIds) {
    return $http({
      method:  'DELETE',
      url:     `${BASE}/${accountId}/roles/${roleId}/roles`,
      data:    childRoleIds,
      headers: { 'Content-Type': 'application/json' }
    });
  };

  // 🔍 Obtener account ID de la sesión actual
  this.getCurrentAccountId = function () {
    const user = JSON.parse(sessionStorage.getItem("user"));
    return user?.id;
  };

}]);
